import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { PageTitle, PageContent, PageLead, EmptyOrdersLead } from 'components/Pages';
import ReviewOrder from './ReviewOrder';
import LoadingReviewOrder from './LoadingReviewOrder';
import Pagination from 'components/Pagination';
import { getReviewList } from 'redux/actions/review';
import { useQuery, useScrollToTop } from 'hooks';

const ReviewPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { products, loading, currentPage, nextPage, previousPage, totalPages } = useSelector((state) => state.review);
    const titleProps = {
        title: !isMobile && 'Moje opinie o produktach',
        url: isMobile && '#',
    };
    const page = useQuery({ param: 'page' });
    const paginationProps = {
        currentPage,
        totalPages,
        nextPage,
        previousPage,
        path: '/review',
    };

    useEffect(() => {
        dispatch(getReviewList(page || 1));
    }, [page, dispatch]);


    useScrollToTop();

    return (
        <section className="page">
            <PageTitle {...titleProps}>{isMobile && 'Moje opinie o produktach'}</PageTitle>
            <PageLead loading={loading}>
                {products && products.length ? (
                    <p className="text-center">Twoja opinia jest ważna - przekaż ją innym!</p>
                ) : (
                        <EmptyOrdersLead />
                    )}
            </PageLead>
            <PageContent>
                {loading ? (
                    <LoadingReviewOrder />
                ) : (
                        <Fragment>
                            {products &&
                                products.length &&
                                products.map((product, i) => <ReviewOrder key={i} selectedId={id} {...product} />)}
                            {totalPages > 1 && <Pagination {...paginationProps} />}
                        </Fragment>
                    )}
            </PageContent>
        </section>
    );
};

export default ReviewPage;
